import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, waLink } from "../../lib/site";
import Logo from "./Logo";

const links = [
  { label: "Collection", href: "#collection" },
  { label: "Categories", href: "#categories" },
  { label: "Catalogue", href: "#catalog" },
  { label: "Our Story", href: "#story" },
  { label: "Visit", href: "#visit" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-cream/85 border-b border-line"
          : "bg-transparent"
      }`}
    >
      <div className="container-narrow flex items-center justify-between py-4 md:py-5">
        <a
          href="#top"
          data-testid="header-logo"
          className="block leading-none"
        >
          <Logo variant={scrolled ? "dark" : "light"} size="md" showHindi />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm tracking-wide transition-colors ${
                scrolled ? "text-ink hover:text-garnet" : "text-cream/90 hover:text-gold-soft"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={waLink("Hi! I'd like to book a bridal consultation.")}
            target="_blank"
            rel="noreferrer"
            data-testid="header-consultation-cta"
            className="btn-primary text-[11px] md:text-xs px-5 py-3"
          >
            Book Bridal Consultation
          </a>
        </div>

        <button
          aria-label="Open menu"
          className={`lg:hidden p-2 transition-colors ${scrolled ? "text-ink" : "text-cream"}`}
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-line bg-cream">
          <div className="container-narrow py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-ink hover:text-garnet transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href={waLink("Hi! I'd like to book a bridal consultation.")}
              target="_blank"
              rel="noreferrer"
              className="btn-primary text-xs mt-2"
              data-testid="mobile-consultation-cta"
            >
              Book Bridal Consultation
            </a>
          </div>
        </div>
      )}

      <p className={`hidden md:block text-center text-[10px] tracking-[0.32em] uppercase py-1.5 transition-colors ${
        scrolled
          ? "text-muteink border-t border-line/70 bg-sand/60"
          : "text-cream/80 border-t border-cream/15 bg-black/30 backdrop-blur"
      }`}>
        {BRAND.tagline} · {BRAND.whatsappDisplay} · Indore
      </p>
    </header>
  );
};

export default Header;
